<template>
	<div class="container-fluid flex-column position-absolute justify-content-center h-100 main" id="addPopup">
		<div class="container bg-light col-lg-8 col-md-8 col-xl-7 col-sm-8 p-5 flex-wrap">
			<div class="container align-items-start justify-content-between ">
				<label for="hostname"
				       class="label">hostname</label>
				<input class="input"
				       type="text"
				       id="hostname"
				       autocomplete="off"></div>
			<div class="container  align-items-start justify-content-between ">
				<label for="address"
				       class="label">address</label>
				<input class="input"
				       type="text"
				       id="address"></div>
			<div class="container  align-items-start justify-content-between ">
				<label for="multiplier"
				       class="label">multiplier</label>
				<input class="input"
				       type="text"
				       id="multiplier"></div>
			<div class="container  align-items-start justify-content-between ">
				<label for="maxlimit"
				       class="label">maxlimit</label>
				<input class="input"
				       type="text"
				       id="maxlimit"></div>
			<div class="container  align-items-start justify-content-between ">
				<label for="live"
				       class="label">live</label>
				<input class="input"
				       type="text"
				       id="live"></div>
			<div class="container  align-items-start justify-content-between ">
				<label for="mysql_port"
				       class="label">mysql_port</label>
				<input class="input"
				       type="text"
				       id="mysql_port"></div>
			<div class="container  align-items-start justify-content-between ">
				<label for="login"
				       class="label">login</label>
				<input class="input"
				       type="text"
				       id="login"
				       autocomplete="off"></div>
			<div class="container  align-items-start justify-content-between ">
				<label for="password"
				       class="label">password</label>
				<input class="input"
				       type="text"
				       id="password"></div>
			<div class="container  align-items-start justify-content-between "
			     v-show="false">
				<label for="operator"
				       class="label">operator</label>
				<select name="operator"
						class="input" id="operator"
						v-model="oneOperators">
					<option v-for="operator in operators"
							:value="operator.name"
							:key="operator.display_name">{{operator.display_name}}</option>
				</select>
			</div>
			<div class="container  align-items-start justify-content-end mt-3">
				<button @click="add"
				        class="btn btn-outline-success">добавить
				</button>
				<button @click="cancel"
				        class="btn btn-outline-danger ml-4">отменить
				</button>
			</div>
			<transition enter-active-class="animated fadeInUp"
			            leave-active-class="animated fadeOutDown">
				<p 	class="text-danger mb-0 pb-0 position-absolute popup"
					v-if="correct">{{ messageError }}</p>
			</transition>
		</div>
	</div>
</template>
<script>
	import { performRequest } from "../script/ws/wsclient";
	import { mapMutations, mapGetters } from "vuex";

	export default {
		name: "AddStreamer",
		data() {
			return {
				correct: false,
				messageError: "",
				operators: [],
				oneOperators: "",
				streamer: {
					hostname: "",
					address: "",
					multiplier: "",
					maxlimit: "",
					live: "",
					mysql_port: "",
					login: "",
					password: "",
					operator: "",
				},
			};
		},
		computed: {
			...mapGetters(["getReqUserRole", "getViewUser"]),
		},
		beforeMount() {
			if (this.getReqUserRole === "Администратор уровня Бог") {
				performRequest(
					{
						section: "tvcontent.operator",
						name: "getOperatorList",
						operator: this.getViewUser
					},
					null,
					a => {
						if (a.code === 200) {
							this.operators = a.data;
						} else {
							console.log("ошибка при получении списка операторов");
						}
					}
				);
			}
		},
		methods: {
			...mapMutations(["setStreamers"]),
			cancel() {
				this.$emit("cancel");
			},
			add() {
				let playlist = {
					hostname: document.getElementById("hostname").value,
					address: document.getElementById("address").value,
					multiplier: document.getElementById("multiplier").value,
					maxlimit: document.getElementById("maxlimit").value,
					live: document.getElementById("live").value,
					mysql_port: document.getElementById("mysql_port").value,
					login: document.getElementById("login").value,
					password: document.getElementById("password").value,
					operator: this.getViewUser,
				};
				// if (this.getReqUserRole === "Администратор уровня Бог") {
				// 	playlist.operator = this.oneOperators;
				// }
				if (
					(this.getReqUserRole === "Администратор уровня Бог" &&
						(document.getElementById("hostname").value &&
							document.getElementById("address").value &&
							document.getElementById("multiplier").value &&
							document.getElementById("maxlimit").value &&
							document.getElementById("live").value &&
							document.getElementById("mysql_port").value &&
							document.getElementById("login").value &&
							document.getElementById("password").value)) ||
					(this.getReqUserRole === "Power User" &&
						(document.getElementById("hostname").value &&
							document.getElementById("address").value &&
							document.getElementById("multiplier").value &&
							document.getElementById("maxlimit").value &&
							document.getElementById("live").value &&
							document.getElementById("mysql_port").value &&
							document.getElementById("login").value &&
							document.getElementById("password").value))
				) {
					performRequest(
						{
							section: "tvcontent.streamer",
							name: "createStreamer",
						},
						playlist,
						a => {
							if (a.code === 200) {
								this.$emit("was_added");

								performRequest(
									{
										section: "tvcontent.streamer",
										name: "getStreamerList",
									},
									{
										operator: this.getViewUser
									},
									a => {
										if (a.code === 200) {
											this.setStreamers(a.data);
										} else {
											console.log("ошибка");
										}
									}
								);

								setTimeout(() => {
									document.getElementById("hostname").value = "";
									document.getElementById("address").value = "";
									document.getElementById("multiplier").value =
										"";
									document.getElementById("maxlimit").value = "";
									document.getElementById("live").value = "";
									document.getElementById("mysql_port").value =
										"";
									document.getElementById("login").value = "";
									document.getElementById("password").value = "";
									document.getElementById("operator").value = "";
								}, 1000);

								console.log(a);
							} else if (a.code === 400) {
								this.errorHandler("введены не корректные данные");
							} else if (a.code === 500) {
								this.errorHandler(
									"ошибка на сервере, либо переданы невалидные данные"
								);
							} else {
								console.log("ошибка =(((");
							}
						}
					);
				} else {
					this.errorHandler("все поля должны быть заполнены");
					// {
					// 	hostname:   null,
					// 	address:    null,
					// 	multiplier: null,
					// 	maxlimit:   null,
					// 	live:       null,
					// 	mysql_port: null,
					// 	login:      null,
					// 	password:   null,
					// 	operator:   null
					// },
				}
			},
			errorHandler(value) {
				this.messageError = value;
				if (!this.correct) {
					this.correct = true;
					setTimeout(() => {
						this.correct = false;
					}, 2500);
				}
			},
			// add() {
			// 	performRequest({
			// 		section: "tvcontent.streamer",
			// 		name:    "getStreamerList"
			// 	},null, a => {
			// 		console.log(a);
			// 	})
			// }
		},
	};
</script>
<style scoped lang="scss">
	@import "~bootstrap/scss/bootstrap";
	div {
		display: flex;
	}
	.main {
		z-index: 1000;
		background-color: rgba(130, 130, 130, 0.27);
	}
	.input {
		width: 70%;
		outline: none;
		min-height: 1.8rem;
		border: 1px solid gray;
		border-radius: 3px;
		transition: all 0.3s;
		padding-left: 5px;
		&:focus {
			border: 1px solid #acafff;
			box-shadow: 0 0 7px #acafff;
		}
	}
	.label {
		width: 100px;
	}
	.popup {
		bottom: 1.5rem;
		font-size: 1.1rem;
		left: 3.8rem;
	}
</style>



// WEBPACK FOOTER //
// src/components/AddStreamer.vue